import axios from "axios";
import { baseUrl } from "../util";

// Flow 39 - Service Life
export const getServiceLife39LCA = ({ productId, setData }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/service-life-39-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setData(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching service life 39:", error);
      setData(null);
    });
};

export const updateServiceLife39LCA = ({
  productId,
  service_life_years,
  source_to_service_life,
  reference_service_life_documentation,
  key_properties_fu,
  design_application_features,
  indoor_environment,
  outdoor_environment,
  standard_of_installation,
  use_conditions,
  special_energy_supply_required,
  special_energy_supply_description,
  callback,
  use_swal = false,
}) => {
  const formData = new FormData();
  
  if (service_life_years !== undefined) {
    formData.append("service_life_years", service_life_years || null);
  }
  if (source_to_service_life !== undefined) {
    formData.append("source_to_service_life", source_to_service_life || null);
  }
  if (reference_service_life_documentation instanceof File) {
    formData.append("reference_service_life_documentation", reference_service_life_documentation);
  } else if (reference_service_life_documentation !== undefined) {
    formData.append("reference_service_life_documentation", reference_service_life_documentation || null);
  }
  if (key_properties_fu !== undefined) {
    formData.append("key_properties_fu", key_properties_fu || null);
  }
  if (design_application_features !== undefined) {
    formData.append("design_application_features", design_application_features || null);
  }
  if (indoor_environment !== undefined) {
    formData.append("indoor_environment", indoor_environment || null);
  }
  if (outdoor_environment !== undefined) {
    formData.append("outdoor_environment", outdoor_environment || null);
  }
  if (standard_of_installation !== undefined) {
    formData.append("standard_of_installation", standard_of_installation || null);
  }
  if (use_conditions !== undefined) {
    formData.append("use_conditions", use_conditions || null);
  }
  if (special_energy_supply_required !== undefined) {
    formData.append("special_energy_supply_required", special_energy_supply_required || null);
  }
  if (special_energy_supply_description !== undefined) {
    formData.append("special_energy_supply_description", special_energy_supply_description || null);
  }

  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/service-life-39-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: formData,
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating service life 39:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update service life",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};


